/* Gift guard v60.
   Gifts follow the REAL number of masks in the cart:
     2+ masks -> free gloves, 3+ masks -> free Mystery Mask too.
   Ice Freaks Ski Mask -> Ice Freaks Snow Gloves + Ice Freaks Mystery Mask
   Mud Freaks Mask     -> Mud Freaks Riding Gloves + Mud Freaks Mystery Mask
   Each family that reaches a threshold gets its own gift; if neither does
   but both together do, the family with more masks gets it (tie: this page).

   v60 FIX (Mystery Mask sometimes $0, sometimes full price at checkout):
   1) A free gift is only turned into a paid one when the lower mask count
      is CONFIRMED on two reads ~0.6s apart. While the theme updates a
      quantity, the cart briefly reports a lower count; v57 reacted to that
      blip and flipped the free Mystery Mask to $26.95 (then back).
   2) Pressing Check out first waits for the cart to be settled and correct,
      then continues to checkout, so the order always has the right price.

   The guard never adds a paid line on its own except that confirmed
   free-to-paid switch. Paid lines added with + are never touched. A gift
   the customer removes stays removed until more masks are added. */
(function(){
var FAM={
ice:{handle:'ice-freaks-ski-mask',masks:[54131546423643,54131546456411,54131546489179,54475332256091]},
mud:{handle:'mud-freaks-mask',masks:[54503563362651,54503565525339,54503565558107,54503565590875]}
};
var GIFTS=[
{grp:'gl',at:2,ice:{free:54136214847835,paid:54321168908635},mud:{free:54497576452443,paid:54497576485211}},
{grp:'my',at:3,ice:{free:54136215437659,paid:54321168941403},mud:{free:54503762887003,paid:54503766491483}}
];
var GIFT_IDS=[];GIFTS.forEach(function(g){['ice','mud'].forEach(function(v){GIFT_IDS.push(g[v].free,g[v].paid);});});
var PAGE=/\/pages\/mud-freaks/.test(location.pathname)?'mud':'ice';
var busy=null,again=false,ours={},inflight=0,declined={},last=null,stable={},pending={};
try{sessionStorage.removeItem('if_gift_declined');}catch(e){}
var ofn=window.fetch;
function post(u,b){return ofn(u,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(b)}).then(function(r){return r.json();});}
function cartNow(){return ofn('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin',cache:'no-store'}).then(function(r){return r.json();});}
function famOfId(id){id=+id;if(FAM.ice.masks.indexOf(id)>-1)return 'ice';if(FAM.mud.masks.indexOf(id)>-1)return 'mud';return null;}
function famOf(it){if(it.handle===FAM.ice.handle)return 'ice';if(it.handle===FAM.mud.handle)return 'mud';return famOfId(it.variant_id);}
function masksBy(cart){var n={ice:0,mud:0};cart.items.forEach(function(it){var f=famOf(it);if(f)n[f]+=it.quantity;});return n;}
function qty(cart,id){var n=0;cart.items.forEach(function(it){if(it.variant_id===id)n+=it.quantity;});return n;}
function keyOf(id){id=+id;for(var i=0;i<GIFTS.length;i++){var g=GIFTS[i];if(id===g.ice.free||id===g.ice.paid)return g.grp+'-ice';if(id===g.mud.free||id===g.mud.paid)return g.grp+'-mud';}return '';}
function earnedFor(m,g){var e={ice:m.ice>=g.at,mud:m.mud>=g.at};if(!e.ice&&!e.mud&&m.ice+m.mud>=g.at){var w=m.mud>m.ice?'mud':(m.ice>m.mud?'ice':PAGE);e[w]=true;}return e;}
function learn(cart){
var m=masksBy(cart),tot=m.ice+m.mud;
Object.keys(declined).forEach(function(k){if(tot>declined[k])delete declined[k];});
if(last){GIFTS.forEach(function(g){['ice','mud'].forEach(function(v){var k=g.grp+'-'+v;var a=qty(last,g[v].free)+qty(last,g[v].paid),b=qty(cart,g[v].free)+qty(cart,g[v].paid);if(a>0&&b===0&&!ours[k])declined[k]=tot;});});}
if(!cart.items.length){declined={};stable={};pending={};}
ours={};
}
var needsRecheck=false;
function plan(cart,confirmNow){
var m=masksBy(cart),tot=m.ice+m.mud,want={};
GIFTS.forEach(function(g){
var e=earnedFor(m,g);
['ice','mud'].forEach(function(v){
var k=g.grp+'-'+v,ids=g[v];
var f=qty(cart,ids.free),p=qty(cart,ids.paid);
var dec=declined[k]!==undefined&&tot<=declined[k];
if(e[v]){
delete pending[k];
if(f>1){p+=f-1;f=1;}
if(f===0&&!dec){if(p>0&&stable[k]===false){p--;}f=1;}
if(f===1)stable[k]=true;
}else if(f>0){
if(stable[k]===true){
if(pending[k]&&pending[k].tot>=tot&&(Date.now()-pending[k].t>=500||confirmNow)){p+=f;f=0;stable[k]=false;delete pending[k];}
else{if(!pending[k])pending[k]={tot:tot,t:Date.now()};needsRecheck=true;}
}else{f=0;}
}else{delete pending[k];if(stable[k]!==true)stable[k]=false;}
want[ids.free]=f;want[ids.paid]=p;
});});
var sets=[],adds=[];
Object.keys(want).forEach(function(k){var id=+k,n=want[k],line=null;cart.items.forEach(function(it){if(it.variant_id===id&&!line)line=it;});var c=line?line.quantity:0;if(n===c)return;if(line)sets.push({key:line.key,quantity:n,id:id});else if(n>0)adds.push({id:id,quantity:n});});
return {sets:sets,adds:adds};
}
function sectionIds(){var h=document.querySelector('[id^="shopify-section"][id*="cart-drawer"]');return h?[h.id.replace('shopify-section-','')]:[];}
function paint(j){var drawer=document.querySelector('cart-drawer');var sid=sectionIds()[0];if(drawer&&j&&j.sections&&sid&&j.sections[sid]){var fresh=new DOMParser().parseFromString(j.sections[sid],'text/html').querySelector('cart-drawer');if(fresh){drawer.innerHTML=fresh.innerHTML;order();return true;}}return false;}
function refreshUI(){var drawer=document.querySelector('cart-drawer');var sid=sectionIds()[0];if(drawer&&sid){return ofn('/?sections='+encodeURIComponent(sid),{headers:{'Accept':'application/json'},credentials:'same-origin'}).then(function(r){return r.json();}).then(function(j){paint({sections:j});}).catch(function(){});}
if(window.location.pathname.indexOf('/cart')===0)window.location.reload();return Promise.resolve();}
function run(confirmNow){
if(inflight>0){return new Promise(function(res){setTimeout(function(){run(confirmNow).then(res);},120);});}
if(busy){again=true;return busy;}
needsRecheck=false;
busy=cartNow().then(function(cart){
if(!cart||!cart.items||inflight>0)return;
if(!last)GIFTS.forEach(function(g){var e=earnedFor(masksBy(cart),g);['ice','mud'].forEach(function(v){if(qty(cart,g[v].free)>0)stable[g.grp+'-'+v]=e[v]?true:'seed';});});
learn(cart);
last=cart;
var p=plan(cart,confirmNow);
if(!p.sets.length&&!p.adds.length)return;
p.sets.forEach(function(x){if(x.quantity===0)ours[keyOf(x.id)]=1;});
var sids=sectionIds(),lastJ=null,chain=Promise.resolve();
if(p.sets.length){var upd={};p.sets.forEach(function(x){upd[x.key]=x.quantity;});chain=chain.then(function(){return post('/cart/update.js',{updates:upd,sections:sids}).then(function(j){lastJ=j;});});}
if(p.adds.length){chain=chain.then(function(){return post('/cart/add.js',{items:p.adds,sections:sids}).then(function(j){lastJ=j;});});}
return chain.then(cartNow).then(function(c){last=c;ours={};if(!paint(lastJ))return refreshUI();});
}).catch(function(){}).then(function(){busy=null;if(needsRecheck)setTimeout(run,600);if(again){again=false;setTimeout(run,60);}});
return busy;
}
function later(){setTimeout(run,60);}
function fixAdd(bodyStr){
var b;try{b=JSON.parse(bodyStr);}catch(e){return Promise.resolve(bodyStr);}
var items=b.items||(b.id?[{id:b.id,quantity:b.quantity||1,properties:b.properties}]:null);
if(!items)return Promise.resolve(bodyStr);
var add={ice:0,mud:0},hasGift=false;
items.forEach(function(it){var f=famOfId(it.id);if(f)add[f]+=(+it.quantity||1);if(GIFT_IDS.indexOf(+it.id)>-1)hasGift=true;});
if(!add.ice&&!add.mud&&!hasGift)return Promise.resolve(bodyStr);
return cartNow().then(function(cart){
var kept=items.filter(function(it){return GIFT_IDS.indexOf(+it.id)<0;});
var m=masksBy(cart);m.ice+=add.ice;m.mud+=add.mud;
if(add.ice||add.mud)declined={};
GIFTS.forEach(function(g){var e=earnedFor(m,g);['ice','mud'].forEach(function(v){if(e[v]&&qty(cart,g[v].free)===0)kept.push({id:g[v].free,quantity:1});});});
var out={items:kept};
Object.keys(b).forEach(function(k){if(k!=='items'&&k!=='id'&&k!=='quantity'&&k!=='properties')out[k]=b[k];});
return JSON.stringify(out);
}).catch(function(){return bodyStr;});
}
window.fetch=function(){
var url=arguments[0],o=arguments[1];var u=(typeof url==='string')?url:(url&&url.url)||'';
var self=this;
if(u.indexOf('/cart/add')>-1&&o&&typeof o.body==='string'){
inflight++;
return fixAdd(o.body).then(function(nb){var o2=Object.assign({},o,{body:nb});return ofn.call(self,url,o2);}).then(function(r){inflight=Math.max(0,inflight-1);later();return r;},function(e){inflight=Math.max(0,inflight-1);throw e;});
}
var p=ofn.apply(this,arguments);
var attrOnly=u.indexOf('/cart/update')>-1&&o&&typeof o.body==='string'&&o.body.indexOf('"attributes"')>-1&&o.body.indexOf('"updates"')<0;
if(u.indexOf('/cart/')>-1&&u.indexOf('cart.js')<0&&!attrOnly){p.then(later).catch(function(){});}
return p;};
var OPEN=XMLHttpRequest.prototype.open,SEND=XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open=function(m,u){this.__ifUrl=u||'';return OPEN.apply(this,arguments);};
XMLHttpRequest.prototype.send=function(){var u=this.__ifUrl||'';if(u.indexOf('/cart/')>-1&&u.indexOf('cart.js')<0){this.addEventListener('load',later);}return SEND.apply(this,arguments);};
/* Check out: settle the cart first, then go. */
var passing=false;
document.addEventListener('click',function(e){
if(passing)return;
var t=e.target;var a=t&&t.closest&&t.closest('[name="checkout"],a[href*="/checkout"]');
if(!a||a.hasAttribute('disabled'))return;
e.preventDefault();e.stopImmediatePropagation();
var go=function(){passing=true;try{if(a.tagName==='A'&&a.href)window.location.href=a.href;else if(a.form&&a.form.requestSubmit)a.form.requestSubmit(a);else a.click();}finally{setTimeout(function(){passing=false;},1500);}};
var done=false;var safety=setTimeout(function(){if(!done){done=true;go();}},4000);
run(true).then(function(){return run(true);}).catch(function(){}).then(function(){if(!done){done=true;clearTimeout(safety);go();}});
},true);
document.addEventListener('click',function(e){var t=e.target;if(t&&t.closest&&t.closest('cart-drawer')&&!t.closest('[name="checkout"]'))setTimeout(run,400);},true);
function rank(t){t=t||'';var add=/Add-on/i.test(t)?1:0;var mud=/Mud Freaks/i.test(t)?5:0;
if(/Mystery/i.test(t))return 40+mud+add;if(/Gloves/i.test(t))return 30+mud+add;if(/Goggles/i.test(t))return 20+mud;if(/Mask/i.test(t))return 10+mud;return 90;}
function order(){
var d=document.querySelector('cart-drawer');if(!d)return;
var qs=d.querySelectorAll('input[name="updates[]"],input[type="number"],quantity-input input');if(qs.length<2)return;
var box=qs[0].parentElement;while(box&&box!==d){var all=true;for(var i=1;i<qs.length;i++){if(!box.contains(qs[i])){all=false;break;}}if(all)break;box=box.parentElement;}
if(!box||box===d)return;
var rows=[].filter.call(box.children,function(c){return c.querySelector('input');});
if(rows.length<2)return;
var keyed=rows.map(function(r,i){return {r:r,k:rank(r.textContent),i:i};});
var sorted=keyed.slice().sort(function(a,b){return a.k-b.k||a.i-b.i;});
if(sorted.every(function(x,i){return x.r===rows[i];}))return;
var anchor=rows[rows.length-1].nextSibling;
sorted.forEach(function(x){box.insertBefore(x.r,anchor);});
}
var oq=0;function soon(){if(oq)return;oq=requestAnimationFrame(function(){oq=0;order();});}
if(window.MutationObserver){new MutationObserver(soon).observe(document.documentElement,{childList:true,subtree:true});}
setInterval(run,1500);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){run();});else setTimeout(run,200);
})();
